import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Favicon from './Favicon.png';
import Survey from './Survey.js'
import Answer from './Answer.js'

function TheApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/Survey" element={<Survey />} />
        <Route path="/Answer" element={<Answer />} />
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <TheApp />
    <Helmet>
  <link
    rel="icon"
    type="image/png"
    sizes="32x32"
    href={Favicon}
  />
</Helmet>

  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
